import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output, SimpleChanges,
  ViewChild,
  ViewChildren
} from '@angular/core'
import { differenceInCalendarDays } from 'date-fns'
import { BaseListComponent } from '../../../classes/base-list.component'
import { ColumnType, OperatorSearch, scopeTableEnum, TypeFieldSearch } from '../../../vss-ui.enum'
import { RowData, SettingTableDynamic, TableAction, TableColum, TableFieldFilterModel } from '../table.model'
import { ConditionSearchModel, OptionModel, SortSearchModel } from '../../../vss-ui.model'
import { PermissionService } from '../../permission/permission.service'
import { NzModalService } from 'ng-zorro-antd/modal'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { VssApiService } from '../../../services/vss-api.service'
import { VssAdminService } from '../../../services/vss-admin.service'
import { cloneDeep, orderBy, sum } from 'lodash'
import { FilterQuery } from '../../../extensions/filter-query'
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop'
import { NzResizeEvent } from 'ng-zorro-antd/resizable'
import { Ultilities } from '../../../extensions/ultilities'
import * as moment from 'moment'
import { VssTableService } from '../vss-table.service'
import { LinkListComponent } from '../link-list/link-list.component'
import FileSaver from 'file-saver'
import { NzMessageService } from 'ng-zorro-antd/message'
import { VssLoadingService } from '../../loading/vss-loading.service'
import { FileService } from '@app/service/admin/file.service'
import { finalize } from 'rxjs/operators'


const FORMAT_DATE = 'DD/MM/YYYY HH:mm'

@Component({
  selector: 'vss-ui-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent extends BaseListComponent implements OnInit, OnChanges {
  @Input() confirmMessageDelete!: string
  @Input() scope: string = scopeTableEnum.COL;
  @Input() isCheckDisable: boolean = false;
  @Input() fixedColumn = false;
  @Input() isEditRow = false;
  @Input() isEditSingleRow = true;
  @Input() sortMultiple = false;
  @Input() isLoading = false;
  @Input() unSelectable = true; //Các bản ghi trong table có được phép click để unselect hay không
  @Input() settingValue: SettingTableDynamic = {
    bordered: true,
    isFilterJs: false,
    loading: false,
    pagination: false,
    sizeChanger: false,
    title: null,
    footer: null,
    checkbox: false,
    simple: false,
    size: 'small',
    tableLayout: 'auto',
  };
  @Input() listOfData: any[] = [];
  @Input() columns: TableColum[] = [];
  @Input() minColShow: number = 5;
  @Input() isReOrderColumn: boolean = false;
  @Input() isDragRow: boolean = false;
  @Input() filterOnPress: boolean = true;
  @Input() isFilter: boolean = true;
  @Input() isResizeAll: boolean = false;
  @Input() isShowSetting = true;
  @Input() loadingDataTable: boolean = false;
  @Input() selectData: any
  @Input() isGetDeleteEvent = false;
  @Input() checkByClickRow = false;
  @Input() checkPermissionData = false;
  @Input() checkFunctionManagement = false; // sử dụng để thao tác thêm sửa xoá hay click tree thì đưa về page 1

  @Input() lastRowData?: RowData | null
  @Input() isTableDynamicCol!: boolean
  @Input() isDBClickAndResetCheck?: boolean
  @Input() isClearChecked?: boolean
  @Input() isShowCursorPointerOnItem?: boolean = false;
  @Input() isHaveFilterHeader?: boolean = false;

  @Input() ruleAdd: string[] = [];
  @Input() ruleDelete: string[] = [];
  @Input() ruleImport: string[] = [];
  @Input() ruleExport: string[] = [];
  @Input() isAdd: boolean = false;
  @Input() isDelete: boolean = false;
  @Input() isImport: boolean = false;
  @Input() isExport: boolean = false;
  @Input() tableName: string = '';
  @Input() paramsDetailTable: Object = {};
  @Input() isReOrderFilterForm: boolean = false;
  @Input() isPreview: boolean = false;
  @Input() isReOrderRow: boolean = false;
  @Input() titleTable: string = '';
  @Input() needApiDownloadFile = false;

  @Output() onAddItem = new EventEmitter<any>();
  @Output() onDeleteItems = new EventEmitter<any>();
  @Output() onImportFile = new EventEmitter<any>();
  @Output() onExportFile = new EventEmitter<any>();

  @Output() onSubmitItem = new EventEmitter<any>();
  @Output() onEditItem = new EventEmitter<any>();
  @Output() onCopyItem = new EventEmitter<any>();
  @Output() onViewItem = new EventEmitter<any>();
  @Output() onAction = new EventEmitter<{ item: any, key: string }>();
  @Output() onSelectLinkItem = new EventEmitter<any>();
  @Output() onCall = new EventEmitter<any>();
  @Output() onClickColData = new EventEmitter<any>();
  @Output() onSubmitItemChildren = new EventEmitter<any>();
  @Output() onRemoveChild = new EventEmitter<any>();
  @Output() onEditChild = new EventEmitter<any>();


  /***
   * @return {
   * force: boolean,
   * filter: any,
   * conditionsSearch: ConditionSearchModel[],
   * sortField: SortSearchModel[]
   * }
   */
  @Output() onFilterData = new EventEmitter<any>();
  @Output() onRemove = new EventEmitter<any>();
  @Output() itemSelected = new EventEmitter<any[]>();
  @Output() itemUnSelected = new EventEmitter<any[]>();
  @Output() onClickItem = new EventEmitter<any[]>();
  @Output() onCheckAll = new EventEmitter<any[]>();
  @Output() onSelectItem = new EventEmitter<any>();
  @Output() onLink = new EventEmitter<any>();
  @Output() onDownloadFile = new EventEmitter<any>();
  @Output() onSelectCombobox = new EventEmitter<any>();
  @Output() onPlay = new EventEmitter<any>();
  @Output() onPause = new EventEmitter<any>();
  @Output() onShowInfo = new EventEmitter<any>();
  @Output() onClickButton = new EventEmitter<any>();
  @Output() onCheckedItems = new EventEmitter<any[]>();
  @Output() onChangeColEdit = new EventEmitter<any>();
  @Output() onReorderRow = new EventEmitter<any[]>();
  @Output() onChangeBtnSwitch = new EventEmitter<any[]>()
  @Output() onSend = new EventEmitter<any>();

  /**
   * Tự động chọn 1 row.
   * ---------------------------------------------------------------
   * autoSelect =  true sẽ tự động chọn row đầu tiên
   * currentItem = ObjectItemData chọn theo row chỉ định
   * * LƯU Ý: 2 params này ko nên set cùng 1 lúc. Chỉ set autoSelect hoặc currentItem
   */
  @Input() autoSelect = false;
  @Input() currentItem: any = null;

  /**
   * ---------------------------------------------------------------
   */
  get COLUMN_TYPE() {
    return ColumnType
  };

  @Input() scrollX: string | null = null;
  @Input() scrollY: string | null = null;
  @Input() pagingOptions = [10, 20, 50, 100];
  @Input() emitOnSetFilter = false
  @Input()
  set setFilter(value: { [key: string]: any }) {
    if (value) {
      Object.keys(value).forEach(
        key => {
          let col = (this.tableColumnData.length ? this.tableColumnData : this.columns).find(c => (c.filter?.name || c.name) == key)
          if (col) {
            this.filter[this.getKeyFilter(key, col.filter?.type || col.type)] = value[key]
          } else {
            col = (this.tableColumnData.length ? this.tableColumnData : this.columns).find(c => this.getKeyFilter(c.filter?.name || c.name, c.filter?.type || c.type) == key)
            if (col) {
              this.filter[key] = value[key]
            }
          }
        }
      )
      if (this.emitOnSetFilter) {
        this.onFilter(true)
      }
    }
  }

  MAX_LENGTH_TEXT = 256;
  colDefaultChecked: string[] = [];

  indeterminateMenu: boolean = false;
  allCheckedMenu = true;
  filter: { [key: string]: any } = {};
  sortField: { [key: string]: any } = {};
  colDateTypes: ColumnType[] = [this.COLUMN_TYPE.DATE_PICKER, this.COLUMN_TYPE.DATE, this.COLUMN_TYPE.DATE_TIME_PICKER, this.COLUMN_TYPE.DATE_TIME_RANGE_PICKER, this.COLUMN_TYPE.DATE_RANGE_PICKER, this.COLUMN_TYPE.DATE_PICKER_YEAR, ColumnType.DATE_RANGE_PICKER_YEAR];
  REGEX_TEXT = /[^a-z0-9 ]/gi;
  dataFiltered: any[] = [];
  sizeOptions: OptionModel[] = [];
  tableHeads: TableColum[][] = [];
  tableColumnData: TableColum[] = [];
  addFields: TableColum[] = [];
  searchFields: TableColum[] = [];
  @Input() tableFieldsAdd: TableColum[] = [];
  @Input() tableFieldsSearch: TableColum[] = [];
  defaultScrollX = '500px';
  widthSetting = 30;
  private pagingCurrent: any
  inputTypeColumn!: number
  totalWidthCols!: number
  @Input() urlSaveConfig = '/setting/save-config-table';
  @Input() urlGetConfig = '/setting/get-config-table';

  @ViewChild('inputIntRef') inputIntRef!: ElementRef
  @ViewChild('inputInputNumberRef') inputInputNumberRef!: ElementRef
  @ViewChild('inputTextareaRef') inputTextareaRef!: ElementRef
  @ViewChild('inputNumberRef') inputNumberRef!: ElementRef
  @ViewChild('inputTextCenterRef') inputTextCenterRef!: ElementRef
  @ViewChildren('inputDefaultRef') inputDefaultRef!: ElementRef[]
  @Input() isCheckDataSelectInt: boolean = false
  @Input() isCheckSaveAddCategoryStaff: boolean = false
  @Input() isCheckboxHeader?: boolean = false; // dùng cho màn thêm mới yêu cầu KCS => tab thông tin hàng hoá/tài sản
  @Output() onChangeCheckboxHeader = new EventEmitter<any>(); // dùng cho màn thêm mới yêu cầu KCS => tab thông tin hàng hoá/tài sản
  @Input() allCheckedKCS: boolean = false; // dùng cho màn thêm mới yêu cầu KCS => tab thông tin hàng hoá/tài sản
  @Input() disabelBtnKCS: boolean = false
  @Input() acceptUpload: any = '.doc, .docx, .pdf, .xls, .xlsx, .jpg, .jpeg, .png'
  // @Input() isChangeNumberOfRow: boolean = false //sửa số lượng của row
  // @Output() onChangeNumberOfRowNumber = new EventEmitter<any>();
  placeholderSearch: any = ''
  placeholderSelect: any = ''
  placeholderInput: any = ''

  getFixRightPx(col: TableColum) {
    return col?.pxRight! ? (this.showSettingCol() ? this.getPxRightAddSetting(col?.pxRight! || '0') : col?.pxRight!) : false
  }
  isArray(val: any): boolean { return Array.isArray(val) }
  tooltipHidenTag(colInfor: any, col: TableColum) {
    return col.options?.filter((item: any) => colInfor.includes(item.value))
      .map((item: any) => item.label)
      .toString().replace(/,/gi, "<br>") || ""
  }
  getLastIndexColChecked() {
    let lastIndex = 0
    this.tableColumnData?.forEach((c, k) => {
      if (c.checked) lastIndex = k
    })
    return lastIndex
  }

  showSettingCol() {
    return this.isShowSetting && (this.tableHeads?.length && this.tableHeads[0].length - 2) > this.minColShow
  }

  getPxRightAddSetting(pxRight: string) {
    return `${(parseInt(pxRight) || 0) + this.widthSetting}px`
  }

  get getScrollX() {
    // return '100vw'
    return (this.totalWidthCols > Number((this.scrollX || this.defaultScrollX).replace('px', ''))
      ? this.totalWidthCols + 'px' : (this.scrollX || this.defaultScrollX))
  }

  constructor(
    private permissionService: PermissionService,
    private notificationService: NzNotificationService,
    private cdr: ChangeDetectorRef,
    private adminServices: VssAdminService,
    private tableService: VssTableService,
    private modalService: NzModalService,
    private message: NzMessageService,
    private loadingService: VssLoadingService,
    private fileService: FileService,
    // public translate: TranslateService
  ) {
    super()
  }

  async getPlaceholder() {
    this.placeholderSearch = 'BASE.SEARCH'
    this.placeholderSelect = 'BASE.SELECT'
    this.placeholderInput = 'BASE.INPUT'

  }

  ngOnInit() {
    this.tableService.convertActionOld(this.columns)
    this.innitCheckedColumn()
    this.getDetailTable()
    if (this.checkPermissionData) {
      this.paging = {
        pageIndex: 1,
        pageSize: 5,
        totalElements: 0,
        totalPages: 1
      }
    }
    this.setupConfigDefaultCol()
    this.colDefaultChecked = this.columns.filter(x => x.checked).map(x => x.name)
    this.listOfData = this.listOfData?.map(x => ({ ...x, checked: x?.checked || false }))
    this.updateEditCache()
    this.onFilterJS()
    this.allCheckedMenu = !this.columns?.find(x => !x.checked)
    this.sizeOptions = this.pagingOptions?.map(x => ({ value: x, label: x?.toString() })) as OptionModel[]

    this._initTableHead()
    this.tableColumnData?.filter(c => c.defaultSort)?.forEach(c => this.sortField[c.name] = c.defaultSort)
    if (Object.keys(this.sortField || {}).length) {
      this.onFilter(true)
    }
    this.getPlaceholder()
  }

  innitCheckedColumn() {
    if (this.tableName) { // nếu có tableName thì call api lấy ds column đã lưu để check
      this.adminServices.getTableColumn(this.urlGetConfig, { tableName: this.tableName })
        .subscribe((res: any) => {
          if (res?.data?.length && res.data[0]?.config.split(',')?.length) {
            let col = res.data[0]?.config.split(',')
            this.columns.forEach(x => {
              x.checked = col.includes(x.name)
              if (x.name === 'action' || x.name === 'index')
                x.checked = true
            })
            this.colDefaultChecked = this.columns.filter(x => x.checked).map(x => x.name)
          }
          this._initTableHead()
        })
    } else {
      this._initTableHead()
    }
  }

  _initTableHead(isResize = false) {
    // if(!this.columns?.filter(c => c.checked)?.some(c => !c.width && c.checked)) {
    //   const colNotFixed = this.columns.filter(c => c.checked && !c.fixedColumn && !c.fixedRight)
    //   colNotFixed[colNotFixed.length > 1 ? colNotFixed.length - 2 : colNotFixed.length - 1].width = undefined
    // }
    const getWidthFixedRight = (c: TableColum): number => {
      if (c.children?.length) {
        return sum(c.children.filter(child => child.fixedRight).map(child => getWidthFixedRight(child)))
      }
      if (!c.fixedRight) {
        return 0
      }
      return c.width && c.width.includes('px') ? parseInt(c.width) : 100
    }
    let totalPxLeft = 0
    let totalPxRight = sum(this.columns.filter(c => c.checked && c.fixedRight).map(c => getWidthFixedRight(c)))
    this.totalWidthCols = sum(this.columns.map(c => c.width && c.width.includes('px') ? parseInt(c.width) : 100))
    const setFixedPxCol = (c: TableColum) => {
      if (c.children?.length) {
        c.children.forEach(child => setFixedPxCol(child))
      } else {
        const cWidth = c.width && c.width.includes('px') ? parseInt(c.width) : 100
        if (c.fixedColumn) {
          c.pxLeft = `${totalPxLeft}px`
          totalPxLeft += cWidth
        }
        if (c.fixedRight) {
          totalPxRight -= cWidth
          c.pxRight = `${totalPxRight}px`
        }
      }
    }
    this.columns.filter(c => c.checked).forEach(c => setFixedPxCol(c))
    const cacheHeader = [...this.tableHeads]
    this.tableHeads = []
    this.tableColumnData = []
    this.columns.forEach(
      c => {
        if (isResize) {
          const headerCompare = cacheHeader[0]?.find(x => x.id === c.id) || c
          c.isHideChildren = headerCompare.isHideChildren
        }
        this._progressTH(0, c, !!c.checked)
        if (c.children && c.children.length > 0) {
          this.showColumnData(c)
        }
      }
    )
    this.setDefaultScrollX()
    this.cdr.detectChanges()
    if (!this.tableFieldsAdd.length)
      this.addFields = cloneDeep(orderBy(this.tableColumnData, 'insertIndex', 'asc'))
    else
      this.addFields = cloneDeep(this.tableFieldsAdd)
    if (!this.tableFieldsSearch.length)
      this.searchFields = cloneDeep(orderBy(this.tableColumnData, 'searchIndex', 'asc'))
    else
      this.searchFields = cloneDeep(this.tableFieldsSearch)
  }

  getDetailTable() {
    // Todo cần làm rõ lại api này
    // if (this.tableName) {
    //   this.adminServices.getDetailTable(this.urlGetConfig, this.paramsDetailTable).subscribe((res: any) => {
    //     this.columns.map(item => {
    //       item.checked = res;
    //     });
    //   });
    // }
  }

  _progressTH(index: number, col: TableColum, checked: boolean) {
    if (index + 1 > this.tableHeads.length) {
      this.tableHeads.push([])
    }
    this.tableHeads[index].push({ ...col, checked })
    if (col.children?.length && !col.isHideTHChildren) {
      col.children.forEach(
        c => {
          this._progressTH(index + 1, c, checked)
        }
      )
    } else {
      this.tableColumnData.push({ ...col, checked })
    }
  }

  getDefaultTdClassByTypeCol(t: any) {
    let classes = ''
    if ([
      ...this.colDateTypes, ColumnType.CHECKBOX,
      ColumnType.DATE,
      ColumnType.ACTION,
      ColumnType.INT,
      ColumnType.TEXT_CENTER,
      ColumnType.CHECKBOX_EDIT,
    ].includes(t)) {
      classes = 'text-center'
    } else if ([ColumnType.NUMBER, ColumnType.INT, ColumnType.INPUT_NUMBER].includes(t)) {
      classes = 'text-right'
    }
    return classes
  }

  clearFilter() {
    this.filter = {}
    this.tableColumnData?.filter(c => c.defaultSort)?.forEach(c => this.sortField[c.name] = c.defaultSort)
    this.onFilter(true)
  }

  onFilterJS() {
    if (!this.settingValue?.isFilterJs) this.dataFiltered = this.listOfData
    else {
      // ---- start fake loading table for search js
      if (this.pagingCurrent?.pageIndex != this.paging.pageIndex) {
        this.loadingDataTable = true
        setTimeout(() => {
          this.loadingDataTable = false
        }, 300)
        this.pagingCurrent = cloneDeep(this.paging)
      }
      // ---- end fake loading table for search js
      const filterQuery = new FilterQuery(this.buildConditionsFilter(), this.buildSortFilter())
      const data = filterQuery.executeSort(
        // đoạn search FE sẽ xử lý data qua executeFilter
        this.listOfData.filter(item => filterQuery.executeFilter(item))
      ).map((v, i) => ({ ...v, index: (i + 1) }))
      this.paging.totalElements = data.length
      if (this.settingValue.pagination) {
        const startItem = (this.paging.pageIndex * this.paging.pageSize) - this.paging.pageSize
        const endItem = this.paging.pageIndex * this.paging.pageSize > data?.length ? data?.length : this.paging.pageIndex * this.paging.pageSize
        this.dataFiltered = data.slice(startItem, endItem)
      } else {
        this.dataFiltered = data
      }
    }
    if (this.autoSelect && this.dataFiltered?.length && this.selectData != this.dataFiltered[0].id) {
      this.dataFiltered = this.dataFiltered.map(x => ({ ...x, checked: false }))
      this.dataFiltered[0].checked = true
      this.onSelectItem.emit(this.dataFiltered[0])
      this.onClick(this.dataFiltered[0])
    }
  }

  getOptionsOfColumn() {
    const params = { configName: this.columns.filter(x => x.configGroupName).map(x => (x.configGroupName)) }
    if (params.configName.length)
      this.adminServices.getConfigParam(params).subscribe((res: any) => {
        this.columns.forEach(col => {
          if (col?.configGroupName) {
            col.filter!.options = res.data.filter((x: any) => x.configName === col.configGroupName).map((x: any) => ({
              value: col.configValue ? x[col.configValue] : x.configCode,
              label: col.configText ? x[col.configText] : x.value
            }))
          }
        })
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.columns) {
      this.getOptionsOfColumn()
      this.columns = this.columns?.map(
        x => {
          x.checked = x?.checked === false ? false : true
          x.filter = {
            ...(x.filter || {}),
            type: x.filter?.type != null ? x.filter?.type : x.type
          }
          x.options = [...x.options || []]
          x.children?.forEach(c => c.checked = c.checked === false ? false : true)
          return x
        }
      )
      this.tableService.convertActionOld(this.columns)
      const colChecked = this.columns.filter((c: any) => c.checked).length
      this.indeterminateMenu = colChecked > 1 && this.columns.length > colChecked
      this.allCheckedMenu = this.columns.length == colChecked
      this._initTableHead()
    }
    if (changes.columns && this.isTableDynamicCol) {
      this.handlerFocusAffterChangeColumn()
    }
    if (this.settingValue.isFilterJs) {
      this.filter = {}
    }
    // if (changes?.listOfData) {
    //   this.currentItem = null;
    //   this.selectData = null;
    // }
    if (this.checkFunctionManagement === true) {
      this.paging.pageIndex = 1
    }
    if (changes?.isClearChecked?.currentValue) {
      this.listOfData = this.listOfData.map(x => ({ ...x, checked: false }))
      this.isClearChecked = false
      this.onCheckAll.emit()
    }
    this.onFilterJS()
  }

  getKeyFilter(name: string, type: any) {
    return `${name}_${type}`
  }

  getKeyFilterByColName(name: string) {
    const col = this.tableColumnData.find(c => c.name == name || c?.filter?.name == name)
    return col ? `${col?.filter?.name || col?.name}_${col?.filter?.type || col.type}` : name
  }

  setupConfigDefaultCol() {
    this.columns?.filter(c => c.type == ColumnType.ACTION)?.forEach(col => {
      col.fixedRight = true
    })
  }

  saveEditCache(data: any) {
    super.saveEditCache(data.id)
    this.onSubmitItem.emit(data)
  }
  saveEditChildren(data: any) {
    this.onSubmitItemChildren.emit(data)
  }

  dropCol(e: CdkDragDrop<string[]>, data: any[]) {
    moveItemInArray(data, e.previousIndex, e.currentIndex)
    this.cdr.detectChanges()
  }

  dropFilterForm(e: CdkDragDrop<string[]>) {
    moveItemInArray(this.searchFields, e.previousIndex, e.currentIndex)
    this.cdr.detectChanges()
  }

  drop(e: CdkDragDrop<string[]>) {
    if (this.isDragRow) {
      moveItemInArray(this.dataFiltered, e.previousIndex, e.currentIndex)
      this.dataFiltered = this.dataFiltered.map((item: any, index: number) => {
        item.index = index + 1
        return item
      })
      this.itemSelected.emit(this.dataFiltered?.filter((data) => data.checked))
    } else
      moveItemInArray(this.columns, e.previousIndex, e.currentIndex)
    this.onReorderRow.emit(this.dataFiltered)
  }

  updateAllCheckedMenu(): void {
    this.colDefaultChecked = this.columns.filter(x => x.checked).map(x => x.name)
    if (this.allCheckedMenu) {
      this.indeterminateMenu = false
      this.columns = this.columns.map(item => ({
        ...item,
        checked: this.allCheckedMenu
      }))
    } else {
      const checkMinCol = (item: any, count: number) => {
        if (this.colDefaultChecked.length == this.columns.length) {
          return count <= this.minColShow || item.name == 'action' || item.name == 'index'
        } else
          return this.colDefaultChecked.includes(item.name)
      }
      this.indeterminateMenu = true
      let countCheck = 0
      this.columns = this.columns?.map((item) => {
        if (item.name != 'action' && item.name != 'index') {
          countCheck += 1
        }
        return {
          ...item,
          checked: checkMinCol(item, countCheck)
          // checked: countCheck <= this.minColShow || item.name == 'action' || item.name == 'index'
        }
      })
      // this.notificationService.error('', `Phải hiển thị ít nhất ${this.minColShow} cột`);
    }
  }

  onChangeShowDropdownSetting(isOpen = false) {
    if (!isOpen) {
      this._initTableHead()
      this.saveColumns()
    }
  }

  saveColumns() {
    if (this.tableName) {
      const body = {
        tableName: this.tableName,
        value: this.columns?.filter(item => !!item.checked).map(item => item.name).toString()
      }
      this.adminServices.saveColumnTable(this.urlSaveConfig, body).subscribe()
    }
  }

  updateMenuItemChecked(i: number): void {
    if (this.columns?.filter(item => item.checked && item.name !== 'index' && item.name !== 'action').length < this.minColShow) {
      setTimeout(() => {
        this.columns[i].checked = true
        this.notificationService.error('', `Phải hiển thị ít nhất ${this.minColShow} cột`)
      }, 0)
      return
    }
    if (this.columns?.every(item => !item.checked)) {
      this.allCheckedMenu = false
      this.indeterminateMenu = false
    } else if (this.columns?.every(item => item.checked)) {
      this.allCheckedMenu = true
      this.indeterminateMenu = false
    } else {
      this.indeterminateMenu = true
      this.allCheckedMenu = false
    }
  }

  changeStatus(item: any = null) {
    const validData = this.displayData?.filter(value => !value.disabled)
    const allChecked = (validData.length > 0 && validData?.every(value => value.checked === true))
      || (!!this.displayData?.length && this.displayData.every(d => d.checked))
    const allUnChecked = validData?.every(value => !value.checked)
    this.allChecked = allChecked
    this.indeterminate = !allChecked && !allUnChecked
    if (item) {
      this.currentItem = item
      this.onCheckedItems.emit(this.dataFiltered?.filter((data) => data.checked))
      if (item.checked) {
        this.itemSelected.emit(this.dataFiltered?.filter((data) => data.checked))
        if (this.currentItem) {
          this.onClickItem.emit(this.currentItem)
        } else {
          this.onClickItem.emit([])
        }
        this.selectData = item?.id
      } else {
        this.itemUnSelected.emit([item])
        this.onClickItem.emit([])
        this.currentItem = null
        this.selectData = null
      }
      this.listOfData = this.listOfData.map(x => ({ ...x, checked: item?.id == x?.id ? item.checked : x.checked }))
    }
  }

  checkAllItem(value: any) {
    this.onCheckAll.emit(value)
    this.dataFiltered = this.dataFiltered?.map(data => {
      return { ...data, checked: !data.disabled ? value : data.checked }
    })
    this.listOfData = this.listOfData?.map(data => {
      return {
        ...data,
        checked: this.dataFiltered?.some(d => d.id == data.id) && !data.disabled ? value : data.checked
      }
    })
    this.changeStatus(null)
    this.onCheckedItems.emit(this.dataFiltered?.filter((data) => data.checked))
    if (value) {
      this.itemSelected.emit(
        this.dataFiltered?.filter((data) => data.checked)
      )
      this.selectData = value?.id
    } else {
      this.itemUnSelected.emit(
        this.dataFiltered?.filter((data) => !data.checked)
      )
      this.selectData = null
    }
  }

  startEdit(item: any) {
    this.onEditChild.emit(item)
    if (this.isEditRow) {
      if (Object.keys(this.editCache).some(k => this.editCache[k].edit) && this.isEditSingleRow) {
        return
      }
      super.startEdit(item)
    } else {
      this.onEditItem.emit({ item: item, tableHeads: this.tableColumnData })
      this.selectData = item.id
    }
  }

  startRemove(item: any) {
    this.onRemove.emit(item)
  }

  startRemoveChild(item: any) {
    this.onRemoveChild.emit(item)
  }
  startEditChild(item: any) {
    this.onEditChild.emit(item)
  }

  copyItem(id: any) {
    this.onCopyItem.emit(id)
    this.selectData = id
  }

  dbClickItem(item: any) {
    if (this.isDBClickAndResetCheck && item) {
      const validDataChecked = this.displayData?.filter(value => !value.disabled && value.checked)
      validDataChecked?.every(value => value.checked = false)
      item.checked = !item.checked
    }
    this.onSelectItem.emit(item)
    this.viewItem(item)
  }

  viewItem(id: any) {
    this.onViewItem.emit({ item: id, tableHeads: this.tableColumnData })
    this.selectData = id
  }

  startCall(item: any) {
    this.onCall.emit(item)
  }

  onClickAction(item: any, key: string) {
    this.onAction.emit({ item, key })
    switch (key) {
      case 'edit':
        this.startEdit(item)
        return
      case 'view':
        this.viewItem(item)
        return
      case 'copy':
        this.copyItem(item)
        return
      case 'delete':
        this.openPopupDelete(item)
        return
      case 'downloadFile':
        this.downloadFile(item)
        return
      case 'play':
        this.play(item)
        return
      case 'info':
        this.showInfo(item)
        return
      case 'send':
        this.send(item)
        return
    }
  }

  onResize({ width }: NzResizeEvent, col: string): void {
    const resize = (e: TableColum) => {
      const data = (e.name === col ? { ...e, width: `${width}px` } : e)
      if (e.children?.length) {
        data.children = e.children.map(ec => resize(ec))
      }
      return data
    }
    this.columns = this.columns?.map(e => resize(e))
    this._initTableHead(true)
  }

  getValueTag(arr: OptionModel[], item: any) {
    return arr?.find((x: OptionModel) => x.value == item)?.label || item
  }

  getColor(arr: OptionModel[], item: any) {
    return arr?.find((x: OptionModel) => x.value == item || x.label === item)?.color || '#667085'
  }

  onFilter(force = false) {
    this.paging.pageIndex = 1
    const data: any = {}
    let arr = this.tableHeads
    if (this.isHaveFilterHeader)
      arr = [this.searchFields]
    arr.forEach(colHead => {
      colHead?.filter(c => {
        const v = this.filter[this.getKeyFilter(c?.filter?.name || c.name, c.filter?.type)]
        return (typeof v == 'number' || !!v) && (!(v instanceof Array) || !!v?.length)
      }).forEach(
        c => {
          let keyFilter = this.getKeyFilter(c?.filter?.name || c.name, c.filter?.type)
          let value = this.filter[keyFilter]
          if (!data[c?.filter?.name || c.name]) {
            data[c?.filter?.name || c.name] = Ultilities.replaceSpecial(value)
          }
          data[keyFilter] = Ultilities.replaceSpecial(value)
        }
      )
    })
    this.onFilterData.next({
      force,
      filter: data,
      conditionsSearch: this.buildConditionsFilter(),
      sortField: this.buildSortFilter()
    })
    this.onFilterJS()
  }

  buildSortFilter(): SortSearchModel[] {
    return Object.keys(this.sortField)?.filter(k => !!this.sortField[k]).map(
      k => ({ fieldName: k, sort: this.sortField[k] })
    ) || []
  }

  buildConditionsFilter(): ConditionSearchModel[] {
    let arr = this.tableColumnData
    if (this.isHaveFilterHeader)
      arr = this.searchFields
    const fieldsFilter: TableFieldFilterModel[] = arr?.filter(c => c.isFilter)?.filter(
      c => {
        const fieldName = c.filter?.name || c.name
        const valueCol = this.filter[this.getKeyFilter(fieldName, c.filter?.type)]
        return (typeof valueCol == 'number' || !!valueCol) && (!(valueCol instanceof Array) || !!valueCol?.length)
      }
    ).map(col => {
      const fieldName = col.filter?.name || col.name
      const typeCol = isNaN(parseInt(`${col?.filter?.type}`)) ? col?.type : col?.filter?.type
      const fieldValue = this.getKeyFilter(fieldName, col.filter?.type)
      return {
        fieldName: fieldName,
        fieldValue: fieldValue,
        multiple: col.filter?.multiple,
        type: typeCol
      }
    })
    return this.tableService.buildConditionsFilter(fieldsFilter, this.filter, this.settingValue?.isFilterJs)
  }

  onClick(item: any) {
    this.currentItem = item === this.currentItem && this.unSelectable ? null : item
    if (this.currentItem) {
      this.onClickItem.emit(item)
    } else {
      this.onClickItem.emit([])
    }
    this.selectData = item?.id
    if (this.checkByClickRow) {
      item.checked = !item.checked
      this.changeStatus(item)
    }
    // if(this.isDBClickAndResetCheck && item) { // campaign marketing
    //   debugger
    //   const validDataChecked = this.displayData?.filter(value => !value.disabled && value.checked);
    //   validDataChecked?.every(value => value.checked = false);
    //   item.checked = !item.checked;
    //   // this.listOfData = this.listOfData.map(x => ({...x, checked: false}));
    // }
  }

  onClickData(item: any, colName: any) {
    this.onClickColData.emit({ row: item, colName })
  }

  onClickLink(item: any) {
    this.onLink.emit(item)
  }

  checkSelectedItem(item: any) {
    // return (this.settingValue.checkbox && item?.checked) || (!this.settingValue.checkbox && this.currentItem?.id === item?.id);
    return this.currentItem?.id === item?.id
  }

  enableTime(currentTime: Date) {
    return false
  }

  disableTime(currentTime: Date) {
    return differenceInCalendarDays(currentTime, new Date()) > 0
  }

  openModalDelete: boolean = false;
  dataDelete: any = {};

  openPopupDelete(item: any) {
    if (this.isGetDeleteEvent) {
      this.onRemove.emit(item)
    } else {
      this.openModalDelete = true
      this.dataDelete = item
    }
  }

  deleteCancel() {
    this.openModalDelete = false
    this.dataDelete = null

  }

  deleteOk(event: any) {
    if (event && (this.dataDelete !== null || this.dataDelete !== undefined)) {
      this.openModalDelete = false
      this.onRemove.emit(this.dataDelete)
    }
  }

  selectLink(item: any) {
    this.onSelectLinkItem.emit(item)
  }

  sortData(fieldName: string) {
    let data: any = {}
    if (!this.sortField[fieldName]) {
      data[fieldName] = 'desc'
    } else if (this.sortField[fieldName] === 'desc') {
      data[fieldName] = 'asc'
    } else {
      delete data[fieldName]
    }
    if (this.sortMultiple) {
      this.sortField[fieldName] = data[fieldName]
    } else {
      this.sortField = data
      if (!Object.keys(this.sortField)?.length) {
        this.tableColumnData?.filter(c => c.defaultSort)?.filter(c => c.name != fieldName)?.forEach(c => this.sortField[c.name] = c.defaultSort)
      }
    }
    this.onFilter(true)
  }


  downloadFile(id: any) {
    this.onDownloadFile.emit(id)
    this.selectData = id
  }

  play(id: any) {
    this.onPlay.emit(id)
    this.selectData = id
  }

  pause(id: any) {
    this.onPause.emit(id)
    this.selectData = id
  }

  showInfo(id: any) {
    this.onShowInfo.emit(id)
    this.selectData = id
  }

  send(item: any) {
    this.onSend.emit(item)
  }

  changePageSize(value: number) {
    this.paging.pageSize = value
    this.changePageIndex(1)
  }

  changePageIndex(value: number) {
    this.paging.pageIndex = value
    this.onFilterJS()
  }

  getTotalColumnActive() {
    return this.tableColumnData.filter(c => c.checked)?.length
  }

  setDefaultScrollX() {
    let totalPX = 0
    this.tableColumnData.filter(c => c.checked && !c.isHidden).forEach(
      x => {
        totalPX += x.width && x.width.includes('px') ? parseInt(x.width) : 100
      }
    )
    this.defaultScrollX = `${totalPX || 500}px`
  }

  onSelectChange(event: any, data: any): void {
    this.onSelectCombobox.emit(data)
  }

  // switch display between parent header and children header
  toggleChildHeader(col: TableColum): void {
    col.isHideChildren = !col.isHideChildren
    this.showColumnData(col)
    this.setDefaultScrollX()
  }

  showColumnData(col: TableColum): void {
    const childrenIds = col.children?.map(x => x.id)
    if (childrenIds && childrenIds.length > 0) {
      this.tableHeads.forEach((colLine, i) => {
        if (i > 0) {
          // find children header data and set isHidden
          const selectedColumn = colLine.filter(c => childrenIds?.includes(c.id))
          selectedColumn?.forEach(x => {
            x.isHidden = col.isHideChildren
          })
        }
      })

      if (col.isHideChildren) {
        // replace child column data with parent column
        const firstDataIndex = this.tableColumnData.findIndex(x => x.id === childrenIds[0])
        if (firstDataIndex > -1) {
          this.tableColumnData.splice(firstDataIndex, childrenIds.length, { ...col, isHidden: false })
          this.cdr.detectChanges()
        }
      } else {
        // replace parent column data with child column
        const firstDataIndex = this.tableColumnData.findIndex(x => x.id === col.id)
        if (firstDataIndex > -1) {
          col.children?.forEach(x => x.isHidden = false)
          this.tableColumnData.splice(firstDataIndex, col.allowToggleChildren ? 1 : childrenIds.length, ...(col.children || []))
          this.cdr.detectChanges()
        }
      }
    }
  }

  onClickBtn(value: any) {
    this.onClickButton.emit(value)
  }

  onChangeInputSearch(type: any) {
    this.inputTypeColumn = type
  }

  handlerFocusAffterChangeColumn() {
    switch (this.inputTypeColumn) {
      case this.COLUMN_TYPE.INT:
        this.inputIntRef.nativeElement.focus()
        break
      case this.COLUMN_TYPE.INPUT_NUMBER:
        this.inputInputNumberRef.nativeElement.focus()
        break
      case this.COLUMN_TYPE.TEXTAREA:
        this.inputTextareaRef.nativeElement.focus()
        break
      case this.COLUMN_TYPE.NUMBER:
        this.inputNumberRef.nativeElement.focus()
        break
      case this.COLUMN_TYPE.TEXT_CENTER:
        this.inputTextCenterRef.nativeElement.focus()
        break
      default:
        this.inputDefaultRef.forEach(item => {
          if (this.inputTypeColumn === item.nativeElement.getAttribute('columntype')) {
            item.nativeElement.focus()
          }
        })
        break
    }
  }

  addItem(value: any) {
    if (this.isPreview && value !== true) {
      this.addFields = value
    } else
      this.onAddItem.emit(value)
  }

  deleteItems(values: any) {
    this.onDeleteItems.emit(values)
  }

  importFile(value: any) {
    this.onImportFile.emit(value)
  }

  dowloadFile(value: any) {
    this.onExportFile.emit(value)
  }

  onChangeCol(value: any, colName: string, data: any) {
    this.onChangeColEdit.emit({ ...data, [colName]: value })
  }

  onChangeColAttrValue(col: TableColum) {
    col!.isEditColAttr = false
    col.attr = col.attr || col.name
  }

  onChangeSwitch(event: any, data: any) {
    const payload: any = {
      isCheckBtnSwitch: event,
      item: data
    }
    this.onChangeBtnSwitch.emit(payload)
  }

  csOpenChange(e: any, data: any, name: any) {
    if (e) {
      this.getCheckedItem(data, name)
    }
  }

  getCheckedItem(listData: any[], selectedItem: any) {
    if (Array.isArray(selectedItem) && selectedItem.length) {
      listData.forEach((item: any) => {
        item.itemChecked = selectedItem.includes(item.value)
        if (item.children && item.children.length > 0) {
          this.getCheckedItem(item.children, selectedItem)
        }
      })
    } else {
      listData.forEach((item: any) => {
        item.itemChecked = selectedItem === item.value
        if (item.children && item.children.length > 0) {
          this.getCheckedItem(item.children, selectedItem)
        }
      })
    }
  }

  @Input() listTitle = 'Danh sách tài liệu'
  @Output() onFileChange = new EventEmitter()

  openLinkedList(data: any, col: any) {
    this.modalService.create({
      nzTitle: this.listTitle,
      nzContent: LinkListComponent,
      nzWidth: '30%',
      nzMaskClosable: false,
      nzKeyboard: false,
      nzFooter: null,
      nzCentered: true,
      nzBodyStyle: { padding: '0px' },
      nzClassName: 'modal-w-content',
      nzCloseIcon: 'icons:icon-close-popup',
      nzComponentParams: {
        listData: data[col.name],
        needDelete: col.needDelete
      },
    }).afterClose.subscribe((res: any) => {
      if (!res) return
      const rowData = this.listOfData.find(v => v.id === data.id)
      rowData.attachFiles = res.attachFiles

      this.emitFile(data.id, res, rowData)
    })
  }

  @Output() onDownloadFileWithPayload = new EventEmitter()
  openLink(data: any, link = null): void {

    if (this.needApiDownloadFile) {
      this.onDownloadFileWithPayload.emit(data)
      return
    }
    FileSaver.saveAs(link || data.fileUrl || data.file)
  }

  @Input() isCheckKcs: boolean = false
  files: any = {}

  upload(uploadFile: any, item: any) {
    const files = uploadFile?.files
    const rowData = this.listOfData.find(v => v.id === item.id)
    const fileList = [...files]


    const a = fileList?.map((x: any) => x?.name.split('.').pop().toLowerCase())
    if (this.acceptUpload) {
      const c = a?.filter((format: any) => !this.acceptUpload?.includes(format))
      if (c?.length > 0) {
        this.message.error(`Tệp không đúng định dạng : ${this.acceptUpload?.toString()}`)
        return
      }
    }
    this.files[item.id] = []
    const addFile = (list: any[]) => {
      const file = list.shift()
      const content = {
        file,
        fileName: file.name,
        format: file.name.split('.').pop(),
        id: Number(new Date().getTime().toString() + Number(rowData.attachFiles?.length)),
        isNew: true,
        fileUrl: file
        // documentCode: item?.documentCode
      }
      const existFile = rowData.attachFiles?.find((item: any) => item.fileName === content.fileName)

      if (existFile) {
        existFile.file = content.file
        existFile.fileName = content.fileName
        existFile.format = content.format
        existFile.id = content.id
        existFile.isNew = content.isNew
        existFile.fileUrl = content.fileUrl
      } else {
        this.files[item.id].push(content)
        if (!rowData.attachFiles) rowData.attachFiles = []
        rowData.attachFiles.push(content)

      }
      if (list.length) addFile(list)

    }
    addFile([...fileList])
    uploadFile.value = null
    this.emitFile(item.id, { attachFiles: rowData.attachFiles, removeList: [] }, rowData)
  }

  deleteFile(item: any): void {
    const rowData = this.listOfData.find(v => v.id === item.id)
    const removeList = []
    if (!item.attachFiles[0]?.isNew) {
      removeList.push(item.attachFiles[0])
    }
    rowData.attachFiles = rowData.attachFiles.filter((v: any) => v.id !== item.attachFiles[0].id)

    this.emitFile(item.id, { attachFiles: rowData.attachFiles, removeList }, rowData)
  }

  emitFile(id: string, fileData: any, rowData: any): void {
    this.files[id] = fileData.attachFiles
    this.onFileChange.emit({ files: this.files, removeList: fileData.removeList })
  }

  onChangeCheckedHeader(event: any) {
    this.onChangeCheckboxHeader.emit(event)
    // this.allCheckedKCS = event
  }

  // onChangeNumberOfRow(value:any, data:any, colName: string){
  //   this.onChangeNumberOfRowNumber.emit({ ...data, [colName]: value })

  // }

  getFirstChar(value: any) {
    if (!value) return ''
    else return value.charAt(0).toUpperCase()
  }

  downloadFileV2(data: any): void {
    this.loadingService.showLoading()
    this.fileService.download(data?.fileId).pipe(
      finalize(() => this.loadingService.hideLoading())
    ).subscribe(file => {
      this.saveToFileSystem(file, data.fileName)
    })
  }

  saveToFileSystem(response: any, fileName: string = 'downloadedFile'): void {
    this.downloadFileLink(response, fileName);
  }

  downloadFileLink(file: Blob, filename: string): void {
    const blob = new Blob([file], { type: 'application/octet-stream' })
    const link = document.createElement('a')
    document.body.appendChild(link)
    link.href = window.URL.createObjectURL(blob)
    link.setAttribute('download', filename)
    link.click()
    document.body.removeChild(link)
  }
}
